// extracted by mini-css-extract-plugin
module.exports = {"MuiAutocomplete-paper":"custom-autocomplete_MuiAutocomplete-paper__2RYVd"};